import { render } from "./card4.vue?vue&type=template&id=685fa77d&scoped=true"
const script = {}

import "./card4.vue?vue&type=style&index=0&id=685fa77d&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685fa77d"]])

export default __exports__